import paymentMethodsInfo from '@assets/images/payment-methods-info.webp';



export const PaymentInfo = () => {

	return (
		<div className='app-payment-info'>
			{process.env.SHOW_CREDIT_CARD_BANNER === 'TRUE' &&
				<img src={paymentMethodsInfo} alt='payment methods info' />
			}
		</div>
	);
}